<template>
    <router-view></router-view>
</template>

<script>
    export default {
        methods: {
            authenticate(){
                if(this.$store.getters.isAuthenticated && !this.$store.state.authenticatedUser){
                    this.$store.dispatch('setUserFromToken');
                }
            }
        },
        computed: {
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            }
        },
        beforeMount(){
            this.$store.dispatch('getToken');
            this.authenticate();
        }
    }
</script>